import React, {PureComponent} from 'react';
import sanitizeHtml from 'sanitize-html';
import SmsCounter from 'sms-counter';
import {Picker} from 'emoji-mart';
import {Callout, Classes, Intent, Popover, PopoverInteractionKind, Position} from "@blueprintjs/core";
import toastr from "toastr";
import {getCurrentUserId, getJwt} from "../../services/authService";
import http from "../../services/httpService";
import {build} from "url-utm-params";
import {Switch as BlueprintSwitch} from "@blueprintjs/core/lib/esm/components/forms/controls";
import ContentEditable from 'react-contenteditable'
import {Tooltip} from "@blueprintjs/core";

export default class ContentEditableTextarea extends PureComponent {
    state = {
        sel: '',
        range: '',
        characterCount: 0,
        messagesCount: 1,
        messageContent: '',
        charsRemaining: 160,
        charsPerMessage: 160, // rows: 5,
        // minRows: 5,
        // maxRows: 20,
        emojiActive: false,
        pauseClosing: false,
        personalize: this.props.personalize ? this.props.personalize : false,
        plan: this.props.plan ? this.props.plan : '',
        personalizeParameters: [],
        viberChars: 0,
        initialContentLoaded: false,
        uniqueId: this.props.uniqueId, //url trackable link states
        loading: false,
        longUrl: '',
        longUrlUtm: '',
        selectedDomain: 'https://oo.fyi/t/',
        title: '',
        shortenedUrl: '', //shortCode: '',
        utmSource: '',
        utmMedium: '',
        utmCampaign: '',
        utmContent: '',
        utmTerm: '',
        customName: '',
        customValue: '',
        utmTracking: false,
        freeMessages: '',
        clipboard: 0,
        selectedSource: this.props.selectedSource,
        cursorPosition: 0,
        selectedSourceFull: this.props.selectedSourceFull, //contenteditable parameters
        html: this.props.html,
        rerunCampaignData: this.props.rerunCampaignData,
        rerunFinished: false,
        firefoxFirstEnter: true,

        //plans data
        plansData: '',
        currentPlanData: ''
    };

    componentDidMount = async () => {
        const isFirefox = typeof InstallTrigger !== 'undefined';
        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

        // console.log('selectedSourceFull: ', this.state.selectedSourceFull)
        //handling plans data and current plan data

        let plansResult = ''
        try {
            plansResult = await http.get('api/emitto_plans/product/emitto_plans', {headers: {authorization: getJwt()}})
        } catch (e) {
            toastr.error('Plans data error.')
        }

        let currentPlanData = plansResult.data.data.find(plan => {
            return plan.plan_id === this.state.plan
        })
        if (plansResult !== '') {
            this.setState({
                plansData: plansResult.data.data, currentPlanData

            })
        }
        document.addEventListener("click", this.closeEmojiMart);

        let div = document.querySelector('#' + this.state.uniqueId)
        //console.info('cdm - div:', div)
        if (div) {
            // console.info('cdm - div exists')
            div.addEventListener('click', this.getSel)

            if (isFirefox) {

                //document.execCommand('insertHTML', false, '<br>')
                // document.execCommand("selectAll", false, null);
                // document.execCommand("Delete", false, null)

                await div.addEventListener('keypress', (e) => {

                    if (e.key === 'Enter') {
                        if (this.state.firefoxFirstEnter) {
                            if (this.state.html === '') {
                                e.preventDefault()
                                e.stopPropagation()
                                //console.log('first enter')
                                div.focus()
                                document.execCommand('insertText', false, '\n')
                                this.setState({
                                    firefoxFirstEnter: false,
                                })
                                this.props.onUpdate('<br>', '\n')
                            } else {
                                e.preventDefault()
                                e.stopPropagation()
                                //console.log('first enter')
                                div.focus()
                                document.execCommand('insertText', false, '\n')
                                this.setState({
                                    firefoxFirstEnter: false,
                                })
                                this.props.onUpdate(this.state.html, this.state.messageContent)
                            }
                        } else {
                            //console.log('not first enter')
                            this.setState({
                                firefoxFirstEnter: false,
                            })
                            this.handleEnter(e)
                        }
                    }
                });
            }

            if (this.state.uniqueId !== "fallback-sms-message") {
                document.querySelector('#' + this.state.uniqueId).focus();
                document.querySelector('#' + this.state.uniqueId).click();
            }
        }

        let selectedSourceFull = ''

        if (

            this.state.user) {
            selectedSourceFull = await this.state.user.sources.data.filter(source => source.id.toString() === this.props.selectedSource)

            // console.info('props: ', this.props)
            if (selectedSourceFull

                [0]) {
                let urlPlatform = selectedSourceFull[0].platforms.filter(platform => platform.platform === 'url')
                //console.info('url platform :', urlPlatform);


                await this
                    .setState({
                        plan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',
                        freeMessages: urlPlatform[0] ? urlPlatform[0].free_messages_remaining : this.state.freeMessages
                    })
            }
        }
        if (this.props.messageContent) {
            this.setState({messageContent: this.props.messageContent, initialContentLoaded: true})
        }


        let textarea = document.querySelector('#' + this.state.uniqueId)

//console.info('editor: ', textarea)
        if (textarea) {
            textarea.addEventListener("paste", function (e) {
                // cancel paste
                e.preventDefault();

                // get text representation of clipboard
                let text = (e.originalEvent || e).clipboardData.getData('text/plain');

                // insert text manually
                document.execCommand("insertHTML", false, text);
            });
        }
        let contentEditableDiv = document.querySelector('#' + this.props.uniqueId)
//console.info('contenteditableDiv: ', contenteditableDiv);
        if (contentEditableDiv) {
            contentEditableDiv.addEventListener("click", e => {

                if (e.target.className === 'delete-personalization-tag') {
                    this.deleteTag(e)
                }
            })
        }

    }
    handleEnter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            e.stopPropagation()
            let range, sel;
            // if (window.getSelection) {
            // IE9 and non-IE
            let html = '<br>'
            sel = this.state.sel
            //console.log('on enter - sel: ', sel)

            //console.info('paste html sel: ', sel)
            // if (sel.getRangeAt && sel.rangeCount) {

            range = this.state.range
            //console.log('on enter - range: ', range)

            // Range.createContextualFragment() would be useful here but is
            // only relatively recently standardized and is not supported in
            // some browsers (IE9, for one)

            let el = document.createElement("div");
            el.innerHTML = html;
            let frag = document.createDocumentFragment(), node, lastNode;
            while ((node = el.firstChild)) {
                lastNode = frag.appendChild(node);
            }
            range.insertNode(frag);


            // Preserve the selection

            if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }

        }
    }
    componentDidUpdate = async () => {
        if (this.state.uniqueId !== this.props.uniqueId) {
            let div = document.querySelector('#' + this.props.uniqueId)
            //console.info('cdu - div:', div)
            if (div) {
                //console.info('cdu - div exists')
                div.addEventListener('click', this.getSel)

                document.querySelector('#' + this.props.uniqueId).focus();
                document.querySelector('#' + this.props.uniqueId).click();

            }
        }
        if (this.state.personalize !== this.props.personalize) {
            // console.info('emoji prop changed: ', this.props.personalize);
            this.setState({
                personalize: this.props.personalize

            })

        }
        if (this.state.plan !== this.props.plan) {

            let plansResult = ''
            try {
                plansResult = await http.get('api/emitto_plans/product/emitto_plans', {headers: {authorization: getJwt()}})
            } catch (e) {
                toastr.error('Plans data error.')
            }

            let currentPlanData = plansResult.data.data.find(plan => {
                return plan.plan_id === this.state.plan
            })
            if (plansResult !== '') {
                this.setState({
                    plansData: plansResult.data.data, currentPlanData

                })
            }

            this.setState({
                plan: this.props.plan
            })
        }
        if (this.state.html !== this.props.html) {
            //console.info('setting html')
            this.setState({
                html: this.props.html + ' '
            })

            // console.log('cdm - div content: ', this.props.html)
            this.cleanHTMLMessage(this.props.html)
        }
        if (this.props.messageContent && !this.state.html) {
            this.setState({
                messageContent: this.props.messageContent, initialContentLoaded: true
            })
        }

        if (this.state.selectedSource !== this.props.selectedSource) {
            this.setState({
                selectedSource: this.props.selectedSource
            })
        }
        if (this.state.selectedSourceFull !== this.props.selectedSourceFull) {
            // console.log('cdu selectedSourceFull: ', this.props.selectedSourceFull)

            this.setState({
                selectedSourceFull: this.props.selectedSourceFull
            })
        }
    }


    toggleEmoji = async (e) => {
        this.checkSel()
        //console.info('target: ', e.target);
        let clickedElement = e.target
        let emojiMart = document.querySelector('#' + this.state.uniqueId + '-wrapper .emoji-mart');
        let emojiToggle = document.querySelector('#' + this.state.uniqueId + '-wrapper .emoji-selector-container');

        if (!emojiMart.contains(clickedElement)) {

            await this.setState({
                emojiActive: !this.state.emojiActive, pauseClosing: !this.state.pauseClosing
            });

            setTimeout(() => this.setState({pauseClosing: false}), 500)
        }
    };

    node_walk = (node, func) => {
        let result = func(node);
        for (node = node.firstChild; result !== false && node; node = node.nextSibling) result = this.node_walk(node, func);
        return result;
    };

//getting caret position INCLUDING html tags counting
    getCaretPosition = (node) => {
        let range = window.getSelection().getRangeAt(0), preCaretRange = range.cloneRange(), caretPosition,
            tmp = document.createElement("div");

        preCaretRange.selectNodeContents(node);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        tmp.appendChild(preCaretRange.cloneContents());
        caretPosition = tmp.innerHTML.length;
        return caretPosition;
    }

    handleEmoji = async (e) => {
        // console.info('e.native: ', e.native)
        const isFirefox = typeof InstallTrigger !== 'undefined';

        let div = document.querySelector('#' + this.props.uniqueId)
        this.pasteHtmlAtCaret(e.native);
        document.execCommand('insertText', false, ' ')
        this.setState({html: div.innerHTML})

        //console.info('divContent: ', divContent)

        //console.info('txt.value: ', txt.value)

        // this.setState({html: txt.value})
        let cleanMessage = this.cleanHTMLMessage(div.innerHTML)
        //console.log('handle emoji - clean message: ', cleanMessage)
        this.props.onUpdate(div.innerHTML, cleanMessage)
        // document.querySelector('#' + this.state.uniqueId).focus()
        // this.getSelAfterChange()

        div.click()
        this.setState({
            emojiActive: true
        })
    };
    checkSel = () => {
        if (this.state.sel === '') {
            document.querySelector('#' + this.state.uniqueId).focus()
            document.querySelector('#' + this.state.uniqueId).click()
        }
    }
    handlePersonalize = async (e) => {

        //console.info('e: ', e.target.innerText)
        let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

        let personalizationTag = e.target.innerText

        //console.info('personalizationTag value: ', personalizationTag)
        let personalizationTagHTML = ''
        let div = document.querySelector('#' + this.props.uniqueId)
        if (!isSafari) {
            personalizationTagHTML = '<span class="tag noselect" contenteditable="false">' + personalizationTag + '<div  class="delete-personalization-tag" contenteditable="false">×</div>' + '</span>' + '&nbsp;'
            this.pasteHtmlAtCaret(personalizationTagHTML);
        } else {
            personalizationTagHTML = '<span class="tag noselect" contenteditable="false">' + personalizationTag + '<div  class="delete-personalization-tag" contenteditable="false">×</div>' + '</span>'
            this.pasteHtmlAtCaret(personalizationTagHTML);
            document.execCommand('insertText', false, ' ')
        }
        //console.info('personalizationTagHtml: ', personalizationTagHTML);


        //let lastFour = div.innerHTML.substr(div.innerHTML.length - 4);
        //console.log('last 4: ', lastFour)
        // if (lastFour === '<br>') {
        //     console.log('last 4 are <br>')
        // }
        this.setState({html: div.innerHTML})


        let cleanMessage = this.cleanHTMLMessage(div.innerHTML)
        //console.info('clean message: ', cleanMessage)

        this.props.onUpdate(div.innerHTML, cleanMessage)

        //EVENT LISTENER FOR X
        let contentEditableDiv = document.querySelector('#' + this.props.uniqueId)
        //console.info('contenteditableDiv: ', contenteditableDiv);
        if (contentEditableDiv) {
            contentEditableDiv.addEventListener("click", e => {

                if (e.target.className === 'delete-personalization-tag') {
                    this.deleteTag(e)
                }
            })
        }

        div.click()
    };

    handleSMSCounter = (message) => {
        //console.log('handle counter: ', message)
        this.setState({
            characterCount: SmsCounter.count(message).length,
            messagesCount: SmsCounter.count(message).messages,
            charsRemaining: SmsCounter.count(message).remaining,
            charsPerMessage: SmsCounter.count(message).per_message,
        })
    }


    closeEmojiMart = (e) => {

        let clickedElement = e.target;
        let isEmojiSpan = false
        // if (clickedElement.getAttribute("style")) {
        //     isEmojiSpan = clickedElement.getAttribute("style").indexOf('unpkg') === 81
        // }
        //console.log('clickedElement: ', clickedElement)
        let textarea = document.querySelector('#' + this.state.uniqueId)
        if (document.querySelector('#' + this.state.uniqueId + '-wrapper .emoji-mart')) {
            let emojiMart = document.querySelector('#' + this.state.uniqueId + '-wrapper .emoji-mart');
            let emojiToggle = document.querySelector('#' + this.state.uniqueId + '-wrapper .emoji-selector-container');

            // console.info('emojiMart: ', emojiMart)
            // console.info('emojiMart: ', emojiToggle)
            if (!emojiMart.contains(clickedElement)) {
                if ((clickedElement !== emojiToggle) && !this.state.pauseClosing && (clickedElement !== textarea)) {
                    //console.info('close emoji');
                    this.setState({emojiActive: false})
                }
            }
        }

    };

    deleteTag = (e) => {
        // console.info('handle delete tag')
        // console.info('delete e: ', e)
        e.target.parentNode.remove();
        let contentEditableDiv = document.querySelector('#' + this.props.uniqueId).innerHTML
        //console.info('contentEditableDiv: ', contentEditableDiv)
        let cleanMessage = this.cleanHTMLMessage(contentEditableDiv)
        this.setState({
            html: contentEditableDiv
        })
        this.props.onUpdate(contentEditableDiv, cleanMessage)
        document.querySelector('#' + this.state.uniqueId).focus()
        this.getSel()
    }

    getSel = async () => {
        this.setState({
            emojiActive: false
        })
        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        const isFirefox = typeof InstallTrigger !== 'undefined';
        let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
        // let isOpera = window.opr !== undefined ?
        //     (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0 : false

        let sel = await window.getSelection()
        //console.info('getSel: ', sel)


        if (isFirefox) {
            if (sel.anchorNode.attributes) {
                if (sel.anchorNode.attributes.id) {
                    if (sel.anchorNode.attributes.id.nodeValue === this.state.uniqueId) {
                        let range = await sel.getRangeAt(0);
                        range.deleteContents();
                        //console.log('sel,range 1: ', sel, range)

                        await this.setState({
                            sel, range
                        })

                    }

                }
            } else {
                if (sel.anchorNode.parentNode.attributes) {
                    if (sel.anchorNode.parentNode.attributes.id) {
                        if (sel.anchorNode.parentNode.attributes.id.nodeValue === this.state.uniqueId) {
                            let range = await sel.getRangeAt(0);
                            range.deleteContents();
                            //console.log('sel,range 2: ', sel, range)

                            await this.setState({
                                sel, range
                            })

                        }

                    }
                }
            }
        } else {
            if (isChrome || isSafari) {
                let range = await sel.getRangeAt(0);
                range.deleteContents();
                //console.log('sel,range 3: ', sel, range)

                await this.setState({
                    sel, range
                })

            } else {
                if (sel.anchorNode.attributes) {
                    if (sel.anchorNode.attributes.id) {
                        if (sel.anchorNode.attributes.id.nodeValue === this.state.uniqueId) {
                            let range = await sel.getRangeAt(0);
                            range.deleteContents();
                            //console.log('sel,range 4: ', sel, range)

                            await this.setState({
                                sel, range
                            })

                        }

                    }
                } else {
                    if (sel.anchorNode.parentNode.attributes) {
                        if (sel.anchorNode.parentNode.attributes.id) {
                            if (sel.anchorNode.parentNode.attributes.id.nodeValue === this.state.uniqueId) {
                                let range = await sel.getRangeAt(0);
                                range.deleteContents();
                                //console.log('sel,range 5: ', sel, range)

                                await this.setState({
                                    sel, range
                                })

                            }
                        }
                    }
                }
            }
        }
    }

    pasteHtmlAtCaret = async (html) => {
        //console.log('pasteHTML at caret HTML: ', html)

        let range, sel;
        // if (window.getSelection) {
        // IE9 and non-IE

        sel = this.state.sel;
        //console.info('paste html sel: ', sel)
        // if (sel.getRangeAt && sel.rangeCount) {

        range = this.state.range

        // Range.createContextualFragment() would be useful here but is
        // only relatively recently standardized and is not supported in
        // some browsers (IE9, for one)
        let el = document.createElement("div");
        el.innerHTML = html;
        let frag = document.createDocumentFragment(), node, lastNode;
        while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
        }
        range.insertNode(frag);


        //console.info('paste html range: ', range)

        // Preserve the selection

        if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }

    cleanHTMLMessage = (html) => {
        let cleanMessage = String(html)
        //console.log('Content editable html: ', html)
        if (cleanMessage.includes('&lt')) {
            cleanMessage = cleanMessage.replace(/&lt;/g, ' ')
        }
        if (cleanMessage.includes('&gt')) {
            cleanMessage = cleanMessage.replace(/&gt;/g, ' ')
        }
        //handling Tags cleaning
        if (cleanMessage.includes('&nbsp;')) {
            cleanMessage = cleanMessage.replace(/&nbsp;/g, ' ')
        }
        if (cleanMessage.includes('<br>')) {
            cleanMessage = cleanMessage.replace(/<br>/g, '\n')
        }
        if (cleanMessage.includes('<div class="delete-personalization-tag" contenteditable="false">×</div>')) {
            cleanMessage = cleanMessage.replace(/<div class="delete-personalization-tag" contenteditable="false">×<\/div>/g, '')
        }
        if (cleanMessage.includes('</span>')) {
            cleanMessage = cleanMessage.replace(/<\/span>/g, '')
        }
        if (cleanMessage.includes('</label>')) {
            cleanMessage = cleanMessage.replace(/<\/label>/g, '')
        }
        if (cleanMessage.includes('<span class="tag noselect" contenteditable="false">first_name')) {
            //console.log('there is first name tag')
            cleanMessage = cleanMessage.replace(/<span class="tag noselect" contenteditable="false">first_name/g, '{first_name}')
        }
        if (cleanMessage.includes('<span class="tag noselect" contenteditable="false">last_name')) {
            //console.log('there is a last name tag')
            cleanMessage = cleanMessage.replace(/<span class="tag noselect" contenteditable="false">last_name/g, '{last_name}')
        }
        if (cleanMessage.includes('<span class="tag noselect" contenteditable="false">full_name')) {
            cleanMessage = cleanMessage.replace(/<span class="tag noselect" contenteditable="false">full_name:/g, '{full_name}')
        }
        if (cleanMessage.includes('<label class="tag trackable-link" contenteditable="false">')) {
            cleanMessage = cleanMessage.replace(/<label class="tag trackable-link" contenteditable="false">/g, '')
        }
        if (cleanMessage.includes('</div><div>')) {
            cleanMessage = cleanMessage.replace(/<\/div><div>/g, '\n')
        }
        if (cleanMessage.includes('<div>')) {
            cleanMessage = cleanMessage.replace(/<div>/g, '\n')
        }

        if (cleanMessage.includes('</div>')) {
            cleanMessage = cleanMessage.replace(/<\/div>/g, "\n")
        }
        if (cleanMessage.includes('<span style="letter-spacing: 0;">')) {
            cleanMessage = cleanMessage.replace(/<span style="letter-spacing: 0;">/g, "")
        }
        if (cleanMessage.includes('«span style= letter-spacing: Opx;"›')) {
            cleanMessage = cleanMessage.replace(/«span style= letter-spacing: Opx;"›/g, "")
        }
        //cleaning all span tags in the end
        if (cleanMessage.match(/<span[^>]*>/g)) {
            cleanMessage = cleanMessage.replace(/<span[^>]*>/g, '')
        }
        if (cleanMessage.match(/<.+?>/g)) {
            cleanMessage = cleanMessage.replace(/<.+?>/g, '')
        }

        //console.log('slice: ', this.state.html.slice(-4))

        // if (cleanMessage.includes('\n\n')) {
        //     cleanMessage = cleanMessage.replaceAll('\n\n', "\n")
        // }
        //cleanMessage = cleanMessage.replaceAll(/<[^>]*>?/gm, '')

        //console.log('ContentEditable clean message: ', cleanMessage)
        this.handleSMSCounter(cleanMessage)
        return cleanMessage

    }


    generateTrackableLink = async () => {

        if (this.state.longUrl !== '') {
            toastr.info('Creating in progress...');
            this.setState({
                loading: true
            })
            let URL_META = await this.state.longUrl;
            let n = await URL_META.startsWith('http');
            let UTM_URL = this.state.longUrlUtm;

            if (n === false) {
                URL_META = 'http://' + URL_META;
                UTM_URL = 'http://' + this.state.longUrlUtm;
            }
            await this.setState({
                longUrl: URL_META, longUrlUtm: UTM_URL
            });

            let domainFormat = ''
            if (this.state.selectedDomain === 'https://oo.fyi/t/') {
                domainFormat = 'oo'
            } else {
                domainFormat = 's'
            }
            let params = {
                url: this.state.plan === 'emitto_free_plan' ? this.state.longUrl : this.state.utmTracking ? this.state.longUrlUtm : this.state.longUrl,
                title: this.state.title || ' ',
                project_id: this.state.selectedSource,
                user_id: getCurrentUserId(),
                domain_format: domainFormat
            };

            try {
                // console.info('params: ', params)
                //console.info('shortening call: ', 'https://short.emitto.io/create')

                const response = await http.post('https://short.emitto.io/create', params)
                    .then(function (response) {
                        //console.info('fetch response: ', response)
                        return response;
                    })
                    .then(function (data) {
                        //console.info('shortening response: ', items)
                        return data;
                    })


                let trackableLinkHTML = '<label class="tag trackable-link" contenteditable="false">' + response.data + '<div  class="delete-personalization-tag" contenteditable="false">×</div>' + '</label>'

                await document.querySelector('#' + this.props.uniqueId)
                this.pasteHtmlAtCaret(trackableLinkHTML)
                document.execCommand('insertText', false, ' ')
                let divContent = document.querySelector('#' + this.props.uniqueId).innerHTML
                // console.info('divContent: ', divContent)
                let txt = document.createElement('textarea')
                txt.innerHTML = divContent
                //console.info('txt.value: ', txt.value)

                await this.setState({
                    shortenedUrl: response.data, loading: false, html: txt.value,
                });

                let cleanMessage = this.cleanHTMLMessage(divContent)

                this.props.onUpdate(txt.value, cleanMessage)
                toastr.success('Link added to message!')

                //EVENT LISTENER FOR DELETE
                let contentEditableDiv = document.querySelector('#' + this.props.uniqueId)
                //console.info('contenteditableDiv: ', contenteditableDiv);
                if (contentEditableDiv) {
                    contentEditableDiv.addEventListener("click", e => {

                        if (e.target.className === 'delete-personalization-tag') {
                            this.deleteTag(e)
                        }
                    })
                }
                document.querySelector('#' + this.props.uniqueId).dispatchEvent(new KeyboardEvent('keydown', {'key': 'a'}));
            } catch (e) {
                // console.info('shorten link response error')

                toastr.error('Something went wrong... Please try again.');
                this.setState({
                    loading: false
                })
            }

        } else {
            toastr.error("URL field can't be empty.")
        }
    };

    handleInput = async (e) => {
        //console.info('input id: ', e.target.id);

        await this.setState({
            [e.target.id]: e.target.value
        });

        if (this.state.longUrl !== '') {
            this.handleCampaign()
        } else {
            await this.setState({
                longUrlUtm: ''
            })
        }
    };

    handleCampaign = async () => {
        let params = {
            utm_source: this.state.utmSource,
            utm_medium: this.state.utmMedium,
            utm_campaign: this.state.utmCampaign,
            utm_content: this.state.utmContent,
            utm_term: this.state.utmTerm,

        };

        if (this.state.customName.length > 0) {
            params[this.state.customName] = this.state.customValue;
        }
        //console.info('params: ', params);


        //cleaning empty params
        Object.keys(params).map((keyName, i) => {
            if (params[keyName] === '') {
                delete params[keyName]
            }
        });


        //console.info('new params: ', params);
        let longUrlUtm = '';

        if (this.state.utmTracking === true) {
            longUrlUtm = await build(this.state.longUrl, params, false)
        } else {
            longUrlUtm = await this.state.longUrl
        }
        await this.setState({
            longUrlUtm
        })
    };
    toggleEnableUTM = async () => {

        let utmTracking = !this.state.utmTracking;

        await this.setState({utmTracking});
        let params = {
            utm_source: this.state.utmSource,
            utm_medium: this.state.utmMedium,
            utm_campaign: this.state.utmCampaign,
            utm_content: this.state.utmContent,
            utm_term: this.state.utmTerm,

        };

        if (this.state.customName.length > 0) {
            params[this.state.customName] = this.state.customValue;
        }
        //console.info('params: ', params);


        //cleaning empty params
        Object.keys(params).map((keyName, i) => {
            if (params[keyName] === '') {
                delete params[keyName]
            }
        });


        //console.info('new params: ', params);
        let longUrlUtm = '';

        if (this.state.utmTracking === true) {
            longUrlUtm = this.state.longUrl.length > 0 ? await build(this.state.longUrl, params, false) : ''
        } else {
            longUrlUtm = this.state.longUrl.length > 0 ? await this.state.longUrl : ''
        }
        //console.info('longUrlUtm: ', longUrlUtm)

        this.setState({
            longUrlUtm
        })
    };

    getProjectShortenedData = async () => {
        if (this.state.longUrl !== '') {
            try {
                const result = await http.get("https://short.emitto.io/project/" + this.props.selectedSource);
                //console.info("result.data.data", result);
            } catch (e) {
                toastr.error(e);
            }
        }
    };
    switchOnChange = () => {
        //console.info('changed');
    }
    copyToClipboard = () => {
        //console.info('shortenedURL: ', document.querySelector('#shortenedUrl').value);
        const myInp = document.getElementById('shortenedUrl');
        myInp.select();
        document.execCommand('Copy')
        this.setState({
            clipboard: 1
        })
        toastr.success('Link copied to clipboard!')
    }

    handleChange = evt => {
        // console.info('handle Change Triggered')
        // console.info('evt: ', evt)

        let txt = document.createElement('textarea')
        //console.log('txt: ', txt)
        txt.innerHTML = evt.target.value
        //console.info('txt.value: ', txt.value)
        if (txt.value.includes('>>')) {
            txt.value = txt.value.replace(/>>/g, ' ')
        }
        if (txt.value.includes('<<')) {
            txt.value = txt.value.replace(/<</g, ' ')
        }

        let cleanMessage = this.cleanHTMLMessage(evt.target.value)
        this.setState({html: txt.value})

        this.props.onUpdate(txt.value, cleanMessage)
        document.querySelector('#' + this.state.uniqueId).focus()
        this.getSel()
    };

    render() {
        const {
            label,
            placeholder,
            height,
            maxCharacters,
            infoCircleType,
            infoCircleContent,
            showMessagesNumber,
            uniqueId,
            viber
        } = this.props;
        const personalizeValues = ['first_name', 'last_name', 'full_name'];


        return (<div id={this.state.uniqueId + '-wrapper'} className="form-group primary-text message-textarea">
            <div className='emoji-textarea-title display-flex items-center justify-content-space'>

                <label style={{marginBottom: 0}} className='!mb-[0px] send-from-text'>{label} <Tooltip
                    className={Classes.TOOLTIP_INDICATOR}
                    content={<div>
                        Using any HTML characters in your message <br/>body might effect your message content
                        or<br/>
                        block your campaign from being sent.
                    </div>}
                    usePortal={false}
                >
                        <span className='ml-[8px] !text-[#344A5E]'>
                            <i className="fas fa-info-circle !text-[#344A5E]"></i>
                        </span>
                </Tooltip></label>

                <div className='flex-direction-row'>
                    {viber ? <p className='character-count'>Characters: <span>
                                    {this.state.characterCount + '/' + maxCharacters}
                                </span>
                    </p> : <React.Fragment>
                        <p className='character-count'>Characters: <span>
                                        {showMessagesNumber ? (this.state.characterCount + '/' + this.state.charsPerMessage * this.state.messagesCount) : (this.state.characterCount + '/' + maxCharacters)}
                            {/*{this.state.charsRemaining}/{showMessagesNumber ? this.state.charsRemaining : maxCharacters}*/}
                                    </span>
                        </p>

                        {showMessagesNumber ? <p className='character-count'> Messages: <span>
                                            {this.state.messagesCount}
                                        </span>
                        </p> : ''}
                    </React.Fragment>}
                </div>
            </div>
            <React.Fragment>

                <ContentEditable
                    id={this.props.uniqueId}
                    innerRef={this.contentEditable}
                    html={this.state.html} // innerHTML of the editable div
                    disabled={false}       // use true to disable editing
                    onClick={this.getSel}
                    // onFocus={this.getSel}
                    onChange={this.handleChange} // handle innerHTML change
                    //onInput={this.handleChange} does nothing
                    //onKeyUp={this.getCursorPosition}
                    tagName='div' // Use a custom HTML tag (uses a div by default)
                    className={`${this.state.characterCount ? 'post-message-text valid' : 'post-message-text'}` + `${window.location.href.indexOf("sms-inbox") > -1 ? ' sms-inbox-textarea' : ''}`}
                />

                <div className="message-options flex-wrap">
                    <div className='emojis-personalize'>
                        <div className="emoji-selector-container" onClick={e => this.toggleEmoji(e)}>
                            <span className='far fa-smile'></span>
                            <span className='caption'>Insert Emoji</span>
                            <Picker
                                autoFocus={false}
                                // native={ this.state.native }
                                style={{display: this.state.emojiActive ? 'block' : 'none'}}
                                onClick={(e) => {
                                    this.handleEmoji(e)
                                }}
                            />
                        </div>

                        {this.state.personalize && this.state.selectedSourceFull ?

                            <div className="personalize-options">
                                {
                                    this.state.selectedSourceFull.custom_plan !== '' &&
                                    this.state.selectedSourceFull.custom_plan.additional_features &&
                                    this.state.selectedSourceFull.custom_plan.additional_features.personalization ?
                                        this.state.selectedSourceFull.custom_plan.additional_features.personalization === 1 ?
                                        <Popover
                                            interactionKind={PopoverInteractionKind.CLICK}
                                            position={Position.BOTTOM}
                                            minimal={true}

                                        >
                                            <div className='flex-direction-row'
                                                 onClick={this.checkSel}
                                            >
                                                <span className="personalize-icon"></span>
                                                Personalize
                                            </div>

                                            <ul className='personalize-popover-content'>
                                                {personalizeValues.map(personalizationTag => {
                                                    return <li key={personalizationTag}
                                                               onClick={(e) => this.handlePersonalize(e)}
                                                               value={personalizationTag}>{personalizationTag}</li>
                                                })}
                                            </ul>

                                        </Popover>

                                        :

                                        <div className='flex-direction-row'
                                             onClick={this.props.triggerUpsellModal}>
                                            <span className="personalize-icon"></span>
                                            Personalize
                                        </div>

                                    :

                                    this.state.selectedSourceFull.plan.additional_features.personalization === 1 ?
                                        <Popover
                                            interactionKind={PopoverInteractionKind.CLICK}
                                            position={Position.BOTTOM}
                                            minimal={true}

                                        >
                                            <div className='flex-direction-row'
                                                 onClick={this.checkSel}
                                            >
                                                <span className="personalize-icon"></span>
                                                Personalize
                                            </div>

                                            <ul className='personalize-popover-content'>
                                                {personalizeValues.map(personalizationTag => {
                                                    return <li key={personalizationTag}
                                                               onClick={(e) => this.handlePersonalize(e)}
                                                               value={personalizationTag}>{personalizationTag}</li>
                                                })}
                                            </ul>

                                        </Popover>
                                        :
                                    <div className='flex-direction-row'
                                         onClick={this.props.triggerUpsellModal}>
                                        <span className="personalize-icon"></span>
                                        Personalize
                                    </div>

                                }

                            </div>

                            :

                            ''
                        }
                        {window.location.pathname === '/new/sms' || window.location.pathname === '/new/viber' || window.location.pathname === '/sms-inbox' ?
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.BOTTOM}
                                minimal={true}
                                className='trackable-link-popover'
                            >
                                <div className='trackable-link-title'>
                                    <i className="fas fa-link"></i>
                                    <span onClick={this.trackableCheckSel} className="caption"> Trackable
                                            link</span>
                                </div>
                                <div
                                    className={window.location.href.indexOf("sms-inbox") > -1 ? 'trackable-link-content trackable-link-content-inbox' : 'trackable-link-content'}>
                                    <h3 className='all-caps grey-text'>Trackable link</h3>
                                    <div className="form-group m-m-b primary-text">
                                        <label className='full-row-label'>Base URL</label>
                                        <textarea autoFocus={true} id='longUrl'
                                                  onChange={(e) => this.handleInput(e)}
                                                  className='post-message-text'
                                                  placeholder='Enter the link you’d like to shorten'
                                                  rows={2}
                                                  value={this.state.longUrl}
                                        />
                                    </div>
                                    <div className="utm-settings">
                                        <BlueprintSwitch
                                            checked={this.state.utmTracking}
                                            label="Add UTM Tags"
                                            onClick={this.toggleEnableUTM}
                                            onChange={this.switchOnChange}
                                        />
                                        {this.state.utmTracking === true ?

                                            <React.Fragment>
                                                {this.state.currentPlanData.url_shortener.utm_tag === 0 ? <Callout
                                                        intent='primary'
                                                        icon='info-sign'
                                                    >
                                                        UTM Tracking is not available on your current
                                                        plan. In order to unlock this
                                                        feature <a
                                                        className='upgrade-now'
                                                        href="#"
                                                        onClick={this.props.utmTagsUnavailableUpsellModal}>Upgrade
                                                        Now.</a>
                                                    </Callout>

                                                    : ''}

                                                <div className="form-group m-m-b">
                                                    <label className='full-row-label'>Campaign Name</label>
                                                    <input id='utmCampaign'
                                                           value={this.state.utmCampaign}
                                                           onChange={(e) => this.handleInput(e)}
                                                           placeholder='ex. Emitto'
                                                           className='fb-sponsored-message-input'
                                                           type="text"/>
                                                </div>
                                                <div className="form-group m-m-b">
                                                    <label className='full-row-label'>Campaign Source</label>
                                                    <input id='utmSource' value={this.state.utmSource}
                                                           onChange={(e) => this.handleInput(e)}
                                                           placeholder='ex. Marketing'
                                                           className='fb-sponsored-message-input'
                                                           type="text"/>
                                                </div>
                                                <div className="form-group m-m-b">
                                                    <label className='full-row-label'>Campaign Medium</label>
                                                    <input id='utmMedium' placeholder='ex. facebook'
                                                           value={this.state.utmMedium}
                                                           onChange={(e) => this.handleInput(e)}
                                                           className='fb-sponsored-message-input'
                                                           type="text"/>
                                                </div>
                                            </React.Fragment> :

                                            ''}
                                        <div className="display-flex button-title-container">
                                            <div className="form-group m-m-b">
                                                <label className='full-row-label'>Title</label>
                                                <input id='title'
                                                       placeholder='Add title for easier differentiation between links'
                                                       onChange={(e) => this.handleInput(e)}
                                                       className='fb-sponsored-message-input'
                                                       type="text"
                                                       value={this.state.title}
                                                />
                                            </div>
                                            {this.state.currentPlanData ? <button
                                                onClick={this.state.freeMessages === 0 ? this.noMessagesRemaining : this.state.currentPlanData.url_shortener.utm_tag === 0 && this.state.utmTracking ? this.props.utmTagsUnavailableUpsellModal : this.generateTrackableLink}
                                                className='btn-action'
                                                disabled={this.state.loading ? true : ''}
                                            >
                                                Generate Trackable Link
                                                {this.state.loading ? <i className='fa fa-spin fa-spinner'></i> : ""}
                                            </button> : ''}
                                        </div>
                                        {this.state.shortenedUrl !== '' ? <React.Fragment>
                                            <div className="form-group">
                                                <label className='full-row-label'>
                                                    Shortened Website URL
                                                </label>
                                                <input readOnly={true} id='shortenedUrl'
                                                       value={this.state.shortenedUrl}
                                                       onChange={(e) => this.handleInput(e)}
                                                       className='fb-sponsored-message-input'
                                                       type="text"/>
                                            </div>
                                            <div className='clipboard-button-container'>
                                                <button onClick={this.copyToClipboard} id='copy'
                                                        className='btn-action'>
                                                    Copy to Clipboard
                                                </button>
                                            </div>
                                        </React.Fragment> : ''}
                                    </div>
                                </div>

                            </Popover> : ''

                        }


                    </div>
                    {this.props.sendButton ?
                        <button onClick={this.props.sendButtonFunction} className='btn-action'>Send</button> : ''}
                </div>
            </React.Fragment>
        </div>)
    }
}